import './Settings.css';
import React from 'react';
import Privacy from './Privacy';

import {
  Switch,
  Route
} from "react-router-dom";

function Settings(props) {

  return (
    <Switch>
      <Route exact path="/settings" render={() => <Privacy {...props} />} />
    </Switch>
  )
}

export default Settings
